import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import { AxiosError } from "axios";
import getErrorProperty from "./config/getErrorProperty";
import { getAuth } from "firebase/auth";
import { GetCategoriesResponse } from "../../api/board_category";

export type TApiBoardCategoriessResult = {
  result?: GetCategoriesResponse;
};

export const fetchBoardCategories = async (): Promise<TApiResult & TApiBoardCategoriessResult> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const authHeader = { headers: { Authorization: `Bearer ${token}` } };
  return await client()
    .board_categories.get(authHeader)
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "fetchBoardCategories");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
